/**
 * @returns the target upgrade package for the origin package
 */
function getLoyaltyTargetUpgradePackage(
  offer: App.Offer | undefined,
  originPackage: App.Package | undefined,
): App.Package | undefined {
  if (!originPackage?.loyalty.targetUpgradePackageUniqueKey || !offer) return
  return offer.packages.find(p => p.uniqueKey === originPackage.loyalty.targetUpgradePackageUniqueKey)
}

export default getLoyaltyTargetUpgradePackage
